import { Button, ButtonBaseProps, ButtonProps, Subtitle02 } from 'Components/designSystem';
import React, { memo, useRef } from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';
import { ellipsis } from 'shared/styles';
import styled from 'styled-components';

import { Z_INDEX_MAP } from '../constants';

interface PageBottomPanelProps {
    animate?: boolean;
    className?: string;
    text?: string;
    buttonProps?: ButtonBaseProps & ButtonProps;
    open?: boolean;
}

const TRANSITION_DURATION_MS = 300;

export const BOTTOM_PANEL_HEIGHT = 74;

function PageBottomPanel(props: PageBottomPanelProps) {
    const { animate, text, buttonProps, className, open } = props;

    const panelRef = useRef<HTMLDivElement>(null);

    return (
        <StickyTransitionGroup enter={ animate }
            exit={ animate }
        >
            { open && (
                <Transition timeout={ TRANSITION_DURATION_MS }
                    nodeRef={ panelRef }
                    mountOnEnter
                    unmountOnExit
                >
                    { (state) => (
                        <Root className={ className }
                            $visible={ !animate || (state === 'entered' || state === 'entering') }
                            ref={ panelRef }
                        >
                            { Boolean(text) && <StyledSubtitle02>{ text }</StyledSubtitle02> }
                            { buttonProps && (
                                <StyledButton color="primary"
                                    size="medium"
                                    { ...buttonProps }
                                />
                            ) }
                        </Root>
                    ) }
                </Transition>
            ) }
        </StickyTransitionGroup>
    );
}

export default memo(PageBottomPanel);

const Root = styled.div<{ $visible?: boolean; $sticky?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${ ({ theme }) => theme.size.size_20 };
    background-color: ${ ({ theme }) => theme.color.white };
    box-shadow: ${ ({ theme }) => theme.shadow.shadow_i1 };
    z-index: ${ Z_INDEX_MAP.bottomControls };
    transition: transform ${ TRANSITION_DURATION_MS }ms;
    transform: ${ ({ $visible }) => ($visible ? `translateY(0)` : `translateY(100%)`) };
`;

export const StickyTransitionGroup = styled(TransitionGroup)`
    position: sticky;
    bottom: 0;
    height: ${ BOTTOM_PANEL_HEIGHT }px;
    overflow: hidden;
`;

const StyledButton = styled(Button)`
    margin-left: auto;
`;

const StyledSubtitle02 = styled(Subtitle02)`
    ${ ellipsis }
`;
